// extracted by mini-css-extract-plugin
module.exports = {"header":"formgraficoevolucaogenetica_header__3LslD"};